import React from 'react'
import PropTypes from 'prop-types'
import {
    Button,
    Flex,
    Image,
    Popover,
    PopoverArrow,
    PopoverBody,
    PopoverContent,
    PopoverTrigger,
    SimpleGrid,
    Text,
    useMultiStyleConfig,
} from '@chakra-ui/react'
import {Link} from 'react-router-dom'
import {FormattedMessage} from 'react-intl'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {safeBuildUrl} from '../../../utils/contentstack-utils'

const LiveChatButton = ({label}) => {
    const style = useMultiStyleConfig('InfoPopover')
    const snapEngageObject =
        typeof window !== 'undefined' && window?.SnapEngage ? window.SnapEngage : {}
    let isProactiveChatAllowed = false

    if (Object.keys(snapEngageObject).length > 0) {
        isProactiveChatAllowed = snapEngageObject?.isProactiveChatAllowed || false
    }

    const handleSnapCall = () => {
        if (isProactiveChatAllowed) window.SnapEngage.openProactiveChat(true, true)
    }

    return isProactiveChatAllowed ? (
        <Button variant="text-button" onClick={handleSnapCall} {...style.ctaLinks}>
            {label}
        </Button>
    ) : (
        <Popover>
            <PopoverTrigger>
                <Button variant="text-button">{label}</Button>
            </PopoverTrigger>
            <PopoverContent {...style.container} data-testid="popover-content">
                <PopoverArrow {...style.arrow} />
                <PopoverBody {...style.body}>
                    <Text {...style.description}>
                        <FormattedMessage
                            id="paperless.liveChat.unavailable"
                            defaultMessage="We apologize for the inconvenience, currently all our agents are unavailable."
                        />
                    </Text>
                </PopoverBody>
            </PopoverContent>
        </Popover>
    )
}

LiveChatButton.propTypes = {
    label: PropTypes.string,
}

const Iconbox = ({iconUrl, title, subtitle, ctaUrl, ctaLabel, isAbsolute, isLiveChat}) => {
    const styles = useMultiStyleConfig('Iconbox')
    const {buildUrl} = useMultiSite()

    const buttonProps = isAbsolute
        ? {
              as: 'a',
              href: ctaUrl,
              target: '_blank',
              rel: 'noopener noreferrer',
          }
        : {
              as: Link,
              to: safeBuildUrl(ctaUrl, buildUrl),
          }

    return (
        <SimpleGrid {...styles.iconboxCard}>
            {iconUrl && <Image src={iconUrl} alt={title} {...styles.icon} />}
            <Flex {...styles.contentWrapper}>
                <Text {...styles.title}>{title}</Text>
                {subtitle && <Text {...styles.subtitle}>{subtitle}</Text>}
            </Flex>
            {isLiveChat ? (
                <LiveChatButton {...styles.liveChatButton} label={ctaLabel} />
            ) : (
                <Button variant="text-button" {...buttonProps} {...styles.ctaLinks}>
                    {ctaLabel}
                </Button>
            )}
        </SimpleGrid>
    )
}

Iconbox.displayName = 'Iconbox'

Iconbox.propTypes = {
    iconUrl: PropTypes.string,
    title: PropTypes.string,
    subtitle: PropTypes.string,
    ctaUrl: PropTypes.string,
    ctaLabel: PropTypes.string,
    isAbsolute: PropTypes.bool,
    isLiveChat: PropTypes.bool,
}

export default Iconbox
